import { Group, Text, ThemeIcon } from '@mantine/core'

interface SectionHeaderProps {
  icon: React.ReactNode
  title: string
}

export function SectionHeader({ icon, title }: SectionHeaderProps) {
  return (
    <Group spacing="sm" mb={16}>
      <ThemeIcon size={28} radius="md" variant="light" color="gray">
        {icon}
      </ThemeIcon>
      <Text weight={600} size="lg" color="#111827">
        {title}
      </Text>
    </Group>
  )
}
